export const productData = {
    "PoolProducts": [{
        "name": "Pool FROG Model 6100",
        "url": "https://www.frogproducts.com/wp-content/uploads/2022/PoolFROG-6100-Cycler.png"
    }, {
        "name": "Pool FROG Model 5400",
        "url": "https://www.frogproducts.com/wp-content/uploads/2022/PoolFROG-5400-Cycler.png"
    }, {
        "name": "Pool FROG XL Pro",
        "url": "https://www.frogproducts.com/wp-content/uploads/2022/PoolFROG-XLPro.png"
    }, {
        "name": "Pool FROG Twin",
        "url": "https://www.frogproducts.com/wp-content/uploads/2022/PoolFROG-Twin.png"
    }, {
        "name": "FROG Leap",
        "url": "https://www.frogproducts.com/wp-content/uploads/2022/Leap-Infuzer.png"
    }, {
        "name": "FROG Leap Twin",
        "url": "https://www.frogproducts.com/wp-content/uploads/2022/Leap-Twin.png"
    }, {
        "name": "Pool Tender Water Care System",
        "url": "https://www.frogproducts.com/wp-content/uploads/2022/PoolTender-Cycler.png"
    }, {
        "name": "Instant FROG",
        "url": "https://www.frogproducts.com/wp-content/uploads/2022/InstantFROG.png"
    }, {
        "name": "Flippin' FROG",
        "url": "https://www.frogproducts.com/wp-content/uploads/2022/FlippinFROG.png"
    }, {
        "name": "Flippin' FROG XL",
        "url": "https://www.frogproducts.com/wp-content/uploads/2022/FlippinFROG-XL.png"
    }, {
        "name": "FROG Algae Barrier",
        "url": "https://www.frogproducts.com/wp-content/uploads/2024/11/90-DAY-ALGAE-BARRIER-30K-FRONTVIEW-FORM.png"
    }, {
        "name": "FROG Algae Gone",
        "url": "https://www.frogproducts.com/wp-content/uploads/2024/11/ALGAE-GONE-30K-FRONTVIEW-FORM.png"
    }, {
        "name": "FROG GoodBye Phos",
        "url": "https://www.frogproducts.com/wp-content/uploads/2024/11/90-DAY-GOODBYE-PHOS-30K-FRONTVIEW-FORM.png"
    }, {
        "name": "FROG GoodBye Cloudy",
        "url": "https://www.frogproducts.com/wp-content/uploads/2024/11/90-DAY-GOODBYE-CLOUDY-30K-FRONTVIEW-FORM.png"
    }],
    "HotTub": [{
        "name": "FROG @ease® Floating System",
        "url": "https://www.frogproducts.com/wp-content/uploads/2022/@ease-Floater.png"
    }, {
        "name": "FROG @ease In-Line System",
        "url": "https://www.frogproducts.com/wp-content/uploads/2022/@ease-Inline.png"
    }, {
        "name": "FROG @ease for Bullfrog Spas, Classic",
        "url": "https://www.frogproducts.com/wp-content/uploads/2022/@ease-Bullfrog.png"
    }, {
        "name": "FROG @ease for Bullfrog Spas, Simplicity",
        "url": "https://www.frogproducts.com/wp-content/uploads/2024/06/FROG®-@ease®-for-Bullfrog-Spas-Simplicity.png"
    }, {
        "name": "FROG @ease XL for Bullfrog Spas, Simplicity",
        "url": "https://www.frogproducts.com/wp-content/uploads/2024/06/FROG®-@ease®-XL-for-Bullfrog-Spas-Simplicity.png"
    }, {
        "name": "FROG @ease for Jacuzzi Hot Tubs",
        "url": "https://www.frogproducts.com/wp-content/uploads/2022/@ease-Jacuzzi.png"
    }, {
        "name": "FROG @ease for Sundance Spas",
        "url": "https://www.frogproducts.com/wp-content/uploads/2022/@ease-Sundance.png"
    }, {
        "name": "FROG @ease for Floating Weir",
        "url": "https://www.frogproducts.com/wp-content/uploads/2024/09/Weir-300.png"
    }, {
        "name": "FROG Serene Floating System",
        "url": "https://www.frogproducts.com/wp-content/uploads/2022/Serene-FLoater.png"
    }, {
        "name": "FROG Serene In-Line System",
        "url": "https://www.frogproducts.com/wp-content/uploads/2022/Serene-Inline.png"
    }, {
        "name": "FROG Filter Mate",
        "url": "https://www.frogproducts.com/wp-content/uploads/2022/FilterMate.png"
    }, {
        "name": "FROG @ease 2-in-1 Water Care",
        "url": "https://www.frogproducts.com/wp-content/uploads/2022/@ease-2-in-1-WaterCare.png"
    }],
    "SwimSpaProducts": [{
        "name": "FROG @ease® Sanitizing System for Swim Spas",
        "url": "https://www.frogproducts.com/wp-content/uploads/2024/05/FROG®-@ease®-for-Swim-Spas.png"
    }],
    "MineralRebate": [{
        name: "FROG Leap Anti-Bac Mineral Pac and 2 Torpedo Pacs",
        url: "https://www.frogproducts.com/wp-content/uploads/2023/01/Leap-Pool-Mineral-Set.png"
    }, {
        name: "Pool FROG Mineral Reservoir and 2 Bac Pacs",
        url: "https://www.frogproducts.com/wp-content/uploads/2023/01/Pool-Frog-Mineral-Set.png"
    }, {
        name: "Pool Tender Mineral Chamber and 2 Chlorine Chambers",
        url: "https://www.frogproducts.com/wp-content/uploads/2023/01/Pool-Tender-Mineral-Set.png"
    }],
};

export const poolProducts = [
    "Pool FROG Model 6100", "Pool FROG Model 5400", "Pool FROG XL Pro", "Pool FROG Twin",
    "FROG Leap", "FROG Leap Twin", "Pool Tender Water Care System", "Instant FROG",
    "Flippin' FROG", "Flippin' FROG XL"]

export const spaProducts = [
    "FROG @ease Floating System", "FROG @ease In-Line System", "FROG @ease for Bullfrog Spas", "FROG @ease for Jacuzzi Hot Tubs",
    "FROG @ease for Sundance Spas", "FROG Serene Floating System", "FROG Serene In-Line System", "FROG Filter Mate",
    "FROG @ease 2-in-1 Water Care"]